import { render, staticRenderFns } from "./CampaignUserEdit.vue?vue&type=template&id=e4227f3e&scoped=true"
import script from "./CampaignUserEdit.vue?vue&type=script&lang=js"
export * from "./CampaignUserEdit.vue?vue&type=script&lang=js"
import style0 from "./CampaignUserEdit.vue?vue&type=style&index=0&id=e4227f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4227f3e",
  null
  
)

export default component.exports